const tdHead  = "background-color:#e0e0e0; font-weight:bold; padding:3px 5px; border:1px solid #bbb; font-size:10px;";
const tdLabel = "border:1px solid #ccc; padding:3px 5px; font-size:10px; vertical-align:top;";
const small   = "font-size:9px; color:#555; display:block; margin-bottom:1px;";
const tdBlue  = "background-color:#c8d8e8; font-weight:bold; padding:4px 5px; font-size:10px; letter-spacing:1px; border:1px solid #aaa;";
const tdBlueLight = "background-color:#e8f0f8; font-size:10px; padding:3px 5px; border:1px solid #bbb;";

function f(value) {
    return value || "-";
}

function lbl(label, value, width) {
    const w = width ? ` style="width:${width}; ${tdLabel}"` : ` style="${tdLabel}"`;
    return `<td${w}><span style="${small}">${label}</span>${f(value)}</td>`;
}

function lblBold(label, value, width) {
    const w = width ? ` style="width:${width}; ${tdLabel}"` : ` style="${tdLabel}"`;
    return `<td${w}><span style="${small}">${label}</span><strong>${f(value)}</strong></td>`;
}

function tbl(rows) {
    return `<table style="width:100%; border-collapse:collapse; margin-bottom:3px;">${rows}</table>`;
}

function head(label, colspan) {
    return `<tr><td colspan="${colspan}" style="${tdHead}">${label}</td></tr>`;
}

export function getEspelhoInfracaoTemplate(espelho) {
    const tv  = espelho.infracao  || {};
    const cfg = espelho.config    || {};
    const processos = espelho.processos || [];
    const printProcessos = espelho.print_mirror_processes && processos.length > 0;

    // ── CABEÇALHO ────────────────────────────────────────────────────────────
    const logoLeft  = process.env.REACT_APP_COMPANY_OWNER_LOGO;
    const logoRight = process.env.REACT_APP_COMPANY_LOGO;
    const header = `
        <table style="width:100%; border-collapse:collapse; margin-bottom:10px;">
            <tr>
                ${logoLeft ? `<td style="width:13%; text-align:center; vertical-align:middle; padding:4px;"><img src="${logoLeft}" style="max-height:65px; max-width:100%;"></td>` : ""}
                <td style="text-align:center; vertical-align:middle; padding:4px;">
                    <div style="font-size:10px;">${f(cfg.company_state_description)}</div>
                    <div style="font-size:11px; font-weight:bold;">${f(cfg.company_owner_name)}</div>
                    <div style="font-size:13px; font-weight:bold;">${f(cfg.company_name)}</div>
                    <div style="font-size:9px;">${f(cfg.company_address)}${cfg.company_district ? ", " + cfg.company_district : ""} — ${f(cfg.company_city)}/${f(cfg.company_uf)}</div>
                    <div style="font-size:9px;">${cfg.company_phone ? "Fone: " + cfg.company_phone : ""}</div>
                </td>
                ${logoRight ? `<td style="width:13%; text-align:center; vertical-align:middle; padding:4px;"><img src="${logoRight}" style="max-height:65px; max-width:100%;"></td>` : ""}
            </tr>
        </table>`;

    // ── TÍTULO ────────────────────────────────────────────────────────────────
    const titulo = `
        <table style="width:100%; border-collapse:collapse; margin-bottom:8px;">
            <tr>
                <td style="text-align:center; border:2px solid #333; padding:5px 0; font-size:13px; font-weight:bold; letter-spacing:1px; background-color:#eeeeee;">
                    ESPELHO DA INFRAÇÃO &mdash; Nº ${f(tv.numero_ait)}
                </td>
            </tr>
        </table>`;

    // ── AUTO DE INFRAÇÃO ──────────────────────────────────────────────────────
    const ait = tbl(`
        ${head("AUTO DE INFRAÇÃO", 5)}
        <tr>
            ${lblBold("Nº AIT",            tv.numero_ait,              "14%")}
            ${lbl(    "Status",            tv.status,                  "22%")}
            ${lbl(    "Lote",              tv.nome_lote,               "18%")}
            ${lbl(    "RENAINF",           tv.codigo_renainf,          "18%")}
            ${lbl(    "Data/Hora da Infração", tv.data_infracao)}
        </tr>`);

    // ── VEÍCULO ───────────────────────────────────────────────────────────────
    const veiculo = tbl(`
        ${head("VEÍCULO", 6)}
        <tr>
            ${lblBold("Placa/UF",    tv.placa_veiculo ? tv.placa_veiculo + "/" + (tv.uf_placa_veiculo || "") : null, "14%")}
            ${lbl(    "RENAVAM",     tv.numero_renavam_veiculo,          "18%")}
            ${lbl(    "Marca/Modelo",tv.descricao_marca_modelo_veiculo,  "24%")}
            ${lbl(    "Cor",         tv.descricao_cor_veiculo,           "14%")}
            ${lbl(    "Espécie",     tv.descricao_especie_veiculo,       "14%")}
            ${lbl(    "Tipo",        tv.descricao_tipo_veiculo)}
        </tr>`);

    // ── PROPRIETÁRIO ──────────────────────────────────────────────────────────
    const proprietario = tbl(`
        ${head("PROPRIETÁRIO", 4)}
        <tr>
            ${lbl("Nome",                     tv.nome_proprietario_veiculo_ait,                                                                                                          "32%")}
            ${lbl("CPF/CNPJ",                 tv.cpf_cnpj_proprietario_veiculo_ait,                                                                                                     "20%")}
            ${lbl("Logradouro / Complemento", tv.logradouro_proprietario_veiculo_ait ? tv.logradouro_proprietario_veiculo_ait + (tv.complemento_imovel_proprietario_veiculo_ait ? ", " + tv.complemento_imovel_proprietario_veiculo_ait : "") : null, "28%")}
            ${lbl("Bairro / Cidade / UF",     [tv.bairro_imovel_proprietario_veiculo_ait, tv.nome_municipio_imovel_proprietario_veiculo_ait, tv.uf_imovel_proprietario_veiculo_ait].filter(Boolean).join(" — "))}
        </tr>`);

    // ── INFRAÇÃO ──────────────────────────────────────────────────────────────
    const infracao = tbl(`
        ${head("INFRAÇÃO", 6)}
        <tr>
            ${lbl(    "Código",            tv.codigo_tipo_infracao,       "10%")}
            ${lbl(    "Desdob.",           tv.desdobramento_tipo_infracao, "9%")}
            ${lbl(    "Gravidade",         tv.gravidade_tipo_infracao,    "12%")}
            ${lbl(    "Pontos",            tv.pontuacao_tipo_infracao,     "9%")}
            ${lbl(    "Artigo (CTB)",      tv.artigo_ctb_tipo_infracao,   "16%")}
            ${lblBold("Valor da Infração (R$)", tv.valor_tipo_infracao)}
        </tr>
        <tr>
            <td colspan="6" style="${tdLabel}"><span style="${small}">Descrição</span>${f(tv.descricao_tipo_infracao)}</td>
        </tr>
        <tr>
            <td colspan="3" style="${tdLabel}"><span style="${small}">Local da Infração</span>${f(tv.logradouro_local_infracao)}${tv.complemento_local_infracao ? " — " + tv.complemento_local_infracao : ""}</td>
            <td colspan="3" style="${tdLabel}"><span style="${small}">Agente Autuador</span>${f(tv.agente_tipo_infracao)}</td>
        </tr>
        ${tv.observacoes ? `<tr><td colspan="6" style="${tdLabel}"><span style="${small}">Observações</span>${tv.observacoes}</td></tr>` : ""}`);

    // ── PAGAMENTO ─────────────────────────────────────────────────────────────
    const pagamento = tv.data_pagamento ? tbl(`
        ${head("PAGAMENTO", 3)}
        <tr>
            ${lbl("Valor Pago (R$)",   tv.valor_pago,    "25%")}
            ${lbl("Data do Pagamento", tv.data_pagamento, "25%")}
            ${lbl("Data do Crédito",   tv.data_credito)}
        </tr>`) : "";

    // ── LINHA DO TEMPO + PROCESSOS ────────────────────────────────────────────
    const tdTl = `border:1px solid #ccc; padding:3px 5px; font-size:10px;`;

    const timelineItems = (tv.timeline || []).map(entry => `
        <tr>
            <td style="width:22%; ${tdTl}">${entry.date}</td>
            <td style="${tdTl}">${entry.description}</td>
        </tr>`).join("");

    const processosHtml = printProcessos ? `
        <tr><td colspan="2" style="${tdBlue}">PROCESSOS ADMINISTRATIVOS</td></tr>
        ${processos.map(proc => {
            const tramitacoes = (proc.tramitacoes || []).map(t => `
                <tr>
                    <td style="${tdTl}">${t.data_criacao || "-"}</td>
                    <td style="${tdTl}">Encaminhado para ${f(t.sigla_unidade)}${t.nome_responsavel ? " — " + t.nome_responsavel : ""}</td>
                </tr>`).join("");

            const limiteJulg = proc.data_limite_julgamento ? `
                <tr>
                    <td style="${tdTl}">${proc.data_limite_julgamento}</td>
                    <td style="${tdTl}">Limite de Defesa</td>
                </tr>` : "";

            const arquivamento = proc.data_arquivamento ? `
                <tr>
                    <td style="${tdTl}">${proc.data_arquivamento}</td>
                    <td style="${tdTl}">Arquivado${proc.nome_arquivador ? " por " + proc.nome_arquivador : ""}${proc.motivo_arquivamento ? ": " + proc.motivo_arquivamento : ""}</td>
                </tr>` : "";

            return `
                <tr>
                    <td colspan="2" style="${tdBlueLight}">
                        <strong>Processo Nº ${proc.numero}</strong>
                        &nbsp;&mdash;&nbsp;${proc.tipo_descricao || proc.tipo}
                        &nbsp;&mdash;&nbsp;Status: <strong>${proc.status}</strong>
                        ${proc.nome_condutor ? `&nbsp;&mdash;&nbsp;Condutor: ${proc.nome_condutor}${proc.cpf_cnpj_condutor ? " (" + proc.cpf_cnpj_condutor + ")" : ""}` : ""}
                    </td>
                </tr>
                <tr>
                    <td style="${tdTl}">${proc.data_criacao || "-"}</td>
                    <td style="${tdTl}">Entrada do Processo</td>
                </tr>
                ${tramitacoes}${limiteJulg}${arquivamento}`;
        }).join("")}` : "";

    const timeline = tbl(`
        ${head("LINHA DO TEMPO", 2)}
        <tr>
            <td style="width:22%; border:1px solid #ccc; padding:3px 5px; font-size:10px; font-weight:bold; text-align:center;">Data/Hora</td>
            <td style="border:1px solid #ccc; padding:3px 5px; font-size:10px; font-weight:bold;">Evento</td>
        </tr>
        ${timelineItems}
        ${processosHtml}`);

    // ── RODAPÉ ────────────────────────────────────────────────────────────────
    const now = new Date().toLocaleString("pt-BR");
    const footer = `
        <table style="width:100%; border-collapse:collapse; margin-top:24px;">
            <tr>
                <td style="width:50%; font-size:9px; vertical-align:bottom; padding:2px 0;">
                    Documento emitido em ${now}
                </td>
                ${cfg.chief_full_name ? `
                <td style="width:50%; text-align:center; vertical-align:bottom; padding:2px 0; border-top:1px solid #333; font-size:10px;">
                    ${cfg.chief_full_name}
                </td>` : ""}
            </tr>
        </table>`;

    return `
        <div class="page" style="max-width:900px; margin:0 auto; padding:30px 40px;">
            ${header}${titulo}${ait}${veiculo}${proprietario}${infracao}${pagamento}${timeline}${footer}
        </div>`;
}
